import { handleDynamicFormLabels } from "./util/dynamicFormLabels";
import { Sentry } from "./sentryInstrument";

document.addEventListener("DOMContentLoaded", () => {
  handleDynamicFormLabels();
  logWhenIframed();
  donateOptions();
});




// Hover dropdown and delay for main desktop navigation
// 990 is breakpoint to show desktop nav
// sets timeout
function waitForSV(callback, timeout = 5000) {
	const startTime = Date.now();

	function check() {
		if (typeof SV !== 'undefined' && SV.HoverIntent) {
			callback();
		} else if (Date.now() - startTime < timeout) {
			setTimeout(check, 100);
		} else {
			console.error('SV library failed to load within timeout period');
		}
	}

	check();

}

waitForSV(() => {

	const dropdowns = document.querySelectorAll(".nav:not(.credits-nav) .dropdown");
	const hoverIntent = new SV.HoverIntent(dropdowns, {
		onEnter: function(targetItem) {
			if (window.innerWidth >= 990) {
				targetItem.querySelector(".dropdown-menu").classList.add('show');
			}
		},
		onExit: function(targetItem) {
			if (window.innerWidth >= 990) {
				targetItem.querySelector(".dropdown-menu").classList.remove('show');
			}
		},
		exitDelay: 1000,
		interval: 100,
		sensitivity: 7,
	});

});




const logWhenIframed = () => {
  if (window.self != window.top) {
    // NOTE: Accessing window.top.document.location.href can throw SecurityError
    // when the page is iframed cross-origin (e.g., in-app browsers like Facebook/Instagram)
    let topHref = 'unknown (cross-origin)';
    try {
      topHref = window.top.document.location.href;
    } catch (crossOriginError) {
      // Cross-origin access blocked - this is expected in in-app browsers
      // Just capture a message without the URL
      if (Sentry && Sentry.captureMessage) {
        Sentry.captureMessage("Being iframed from cross-origin source", "info");
      }
      return;
    }
	const message = `Being iframed from ${topHref}`;
	if (Sentry && Sentry.captureMessage) {
	  Sentry.captureMessage(message, "warning");
	} else {
	  throw Error(message);
	}
  }
}

function donateOptions() {
  const donateOptionsBtn = document.getElementById("donate-options");
  const donateOptionsDropdown = document.getElementById("donate-options-dropdown");
  if (donateOptionsBtn) {
    donateOptionsBtn.addEventListener("click", function(event) {
      donateOptionsBtn.classList.toggle("active");
      if (donateOptionsDropdown) {
        donateOptionsDropdown.classList.toggle("show");
      }
    });
  }
}
